define('cloud-api',['require','exports','module'],function(require, exports, module) {
    'use strict';

    module.exports = new Promise(function(resolve) {
        window.__cloudApi__ && window.__cloudApi__.ready().then(function() {
            resolve(window.__cloudApi__);
        });
    });
});

